import { cn } from "@omni/utils/styles";
import React, { LabelHTMLAttributes } from "react";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
    children?: React.ReactNode;
    className?: string;
    hidden?: boolean;
};

const Label = ({ children, className, htmlFor, hidden }: LabelProps) => {
    return (
        <label
            className={cn(
                "tw:inline-block",
                hidden ? "tw:sr-only" : false,
                className
            )}
            htmlFor={htmlFor}
        >
            {children}
        </label>
    );
};

export { Label };
